import { useContext, useState } from "react";
import { Box } from "@chakra-ui/react";
import "./App.css";
import AllRoutes from "./routes/AllRoutes";
import { AppContext } from "./context/AppContext";

function App() {

  return (
    <Box minH="100vh">
      <AllRoutes />
    </Box>
  );
}

export default App;
